// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-q_fJ","advertDetailService__price":"c-q_fK"};